import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import validateMessageInput from '../../../validation/contact';
import LoaderButton from '../../common/LoaderButton/LoaderButton';


class Form extends Component {
  static propTypes = {
    course: PropTypes.string
  };

  state = {
    name: '',
    email: '',
    tel: '',
    message: 'Kedves Melinda,\nJelentkezni szeretnék az ingyenes próbaórára...',
    terms: false,

    sending: false,
    success: false,
    failed: false,

    errors: {}
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onCheck = (e) => {
    this.setState({ terms: e.target.checked });
  }

  onSubmit = (e) => {
    e.preventDefault();

    const { isValid, errors } = validateMessageInput(this.state);
    if (!isValid) return this.setState({ errors });

    this.setState({ sending: true });

    const formData = `name=${this.state.name}&course=Próbaóra&email=${this.state.email}&tel=${this.state.tel}&message=${this.state.message}&terms=${this.state.terms}`;


    fetch(`${window.location.origin}/mail/contact.php`, {
      method: 'POST',
      body: formData,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(res => res.text())
    .then(res => {
      if (res.status < 200 || res.status >= 300) {
        this.setState({ failed: true });
        setTimeout(() => this.setState({ sending: false, failed: false }), 3000);
        return;
      }

      this.setState({ sending: false, success: true });
      setTimeout(() => {
        this.setState({
          name: '',
          email: '',
          tel: '',
          message: '',
          terms: false,

          errors: {},

          success: false
        });
      }, 3000);
    })
    .catch(err => {
      this.setState({ failed: true });
      this.captcha.reset();
      setTimeout(() => this.setState({ sending: false, failed: false }), 3000);
    });
  }

  render() {
    return (
      <form noValidate onSubmit={this.onSubmit} className="d-flex flex-column">

          <div className="form-group">
            <label htmlFor="name">Név</label>
            <input
              type="text"
              className={classnames('form-control', {
                'is-invalid': this.state.errors.name
              })}
              disabled={this.state.sending}
              id="name"
              name="name"
              aria-describedby="name"
              value={this.state.name}
              onChange={this.onChange}
            />
            {this.state.errors.name && <div className="invalid-feedback">{this.state.errors.name}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="email">Email cím</label>
            <input
              type="email"
              className={classnames('form-control', {
                'is-invalid': this.state.errors.email
              })}
              disabled={this.state.sending}
              id="email"
              name="email"
              aria-describedby="email"
              value={this.state.email}
              onChange={this.onChange}
            />
            {this.state.errors.email && <div className="invalid-feedback">{this.state.errors.email}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="tel">Telefonszám</label>
            <input
              type="tel"
              className={classnames('form-control', {
                'is-invalid': this.state.errors.tel
              })}
              disabled={this.state.sending}
              id="tel"
              name="tel"
              aria-describedby="tel"
              value={this.state.tel}
              onChange={this.onChange}
            />
            {this.state.errors.tel && <div className="invalid-feedback">{this.state.errors.tel}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="message">Üzenet</label>
            <textarea
              className={classnames('form-control', {
                'is-invalid': this.state.errors.message
              })}
              disabled={this.state.sending}
              id="message"
              name="message"
              rows="3"
              value={this.state.message}
              onChange={this.onChange}
            />
            {this.state.errors.message && <div className="invalid-feedback">{this.state.errors.message}</div>}
          </div>

          <div
            className="form-group">
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className={classnames('custom-control-input', {
                  'is-invalid': this.state.errors.terms
                })}
                name="terms"
                id="terms"
                checked={this.state.terms}
                onChange={this.onCheck}
              />
              <label
                className="custom-control-label"
                htmlFor="terms"
                style={{ userSelect: 'none' }}
              >
                Elfogadom az <Link to="/adatkezeles">adatkezelési irányelveket</Link>
              </label>
            </div>
          </div>

          <LoaderButton
            value="Küldés"
            load={this.state.sending}
            check={this.state.success}
            fail={this.state.failed}
          />

        </form>
    );
  }
}


export default Form;



// WEBPACK FOOTER //
// ./src/components/Home/Courses/FormProbaora.js